module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"no_data":"公開されている求人情報はありません。"}}')
  delete Component.options._Ctor
}
